(() => {
  if (window.__pzCompetitorPurchaseOfferV2) return;
  window.__pzCompetitorPurchaseOfferV2 = true;

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const offers = [
    { spend: 'Buy 2', saving: '10% off', code: 'PER10' },
    { spend: 'Buy 3', saving: '15% off', code: 'PER15' },
    { spend: 'Buy 5', saving: '20% off', code: 'PER20' }
  ];

  const bindCopyButtons = (root) => {
    root?.querySelectorAll('[data-pz-copy-code]').forEach((button) => {
      if (button.dataset.pzReady === 'true') return;
      button.dataset.pzReady = 'true';
      button.addEventListener('click', async () => {
        const code = button.dataset.pzCopyCode || '';
        const label = button.querySelector('span');
        try {
          await navigator.clipboard.writeText(code);
          if (label) label.textContent = 'Copied!';
          window.setTimeout(() => {
            if (label) label.textContent = code;
          }, 1100);
        } catch (_) {
          window.prompt('Copy discount code', code);
        }
      });
    });
  };

  const syncBundleRows = (bundle) => {
    const table = bundle?.querySelector('.pz-bundle-table');
    if (!table) return;

    const rows = Array.from(table.querySelectorAll('.pz-bundle-row:not(.pz-bundle-head)'));
    const alreadyCorrect = rows.length === offers.length && offers.every((offer, index) => {
      const row = rows[index];
      const cells = row?.querySelectorAll('[role="cell"]');
      const codeButton = row?.querySelector('[data-pz-copy-code]');
      return cells?.length >= 3 &&
        normalize(cells[0].textContent) === offer.spend &&
        normalize(cells[1].textContent) === offer.saving &&
        codeButton?.dataset.pzCopyCode === offer.code;
    });

    if (alreadyCorrect) {
      bindCopyButtons(bundle);
      return;
    }

    rows.forEach((row) => row.remove());

    offers.forEach((offer) => {
      const row = document.createElement('div');
      row.className = 'pz-bundle-row';
      row.setAttribute('role', 'row');

      const spend = document.createElement('span');
      spend.setAttribute('role', 'cell');
      spend.textContent = offer.spend;

      const saving = document.createElement('strong');
      saving.setAttribute('role', 'cell');
      saving.textContent = offer.saving;

      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('role', 'cell');
      button.dataset.pzCopyCode = offer.code;

      const code = document.createElement('span');
      code.textContent = offer.code;
      const copyIcon = document.createElement('span');
      copyIcon.setAttribute('aria-hidden', 'true');
      copyIcon.textContent = '▣';

      button.append(code, copyIcon);
      row.append(spend, saving, button);
      table.appendChild(row);
    });

    bindCopyButtons(bundle);
  };

  const ensureCompetitorBundle = () => {
    const info = document.querySelector('.product__info-container');
    if (!info) return;

    let bundle = info.querySelector('.pz-bundle');
    if (!bundle) {
      const template = document.querySelector('[data-pz-bundle-template]');
      const source = template?.content?.firstElementChild;
      if (source) {
        bundle = source.cloneNode(true);
        const trustBadge = info.querySelector('.trust-badge-container');
        const accordion = info.querySelector('.product-info-container');
        if (trustBadge) trustBadge.insertAdjacentElement('afterend', bundle);
        else if (accordion) accordion.insertAdjacentElement('beforebegin', bundle);
        else info.appendChild(bundle);
      }
    }

    syncBundleRows(bundle);
  };

  const hideLegacyBundle = () => {
    const info = document.querySelector('.product__info-container');
    if (!info) return;

    const candidates = Array.from(info.querySelectorAll('section, div, table')).filter((element) => {
      if (
        element.classList.contains('pz-bundle') ||
        element.closest('.pz-bundle') ||
        element.querySelector('.pz-bundle') ||
        element.querySelector('.product-form__submit, #tee-artwork-form, .product-form__quantity, .trust-badge-container')
      ) return false;

      const text = normalize(element.textContent);
      return text.length < 2400 &&
        text.includes('PER10') &&
        text.includes('PER15') &&
        text.includes('PER20');
    });

    if (!candidates.length) return;
    candidates.sort((a, b) => normalize(a.textContent).length - normalize(b.textContent).length);

    let target = candidates[0];
    for (let index = 0; index < 5; index += 1) {
      const parent = target.parentElement;
      if (!parent || parent === info || parent.querySelector('.pz-bundle')) break;
      const text = normalize(parent.textContent);
      if (
        text.length < 2600 &&
        text.includes('PER10') &&
        text.includes('PER15') &&
        text.includes('PER20') &&
        /spend more/i.test(text) &&
        !parent.querySelector('.product-form__submit, #tee-artwork-form, .product-form__quantity, .trust-badge-container')
      ) {
        target = parent;
      } else {
        break;
      }
    }

    target.hidden = true;
    target.style.setProperty('display', 'none', 'important');

    const previous = target.previousElementSibling;
    if (
      previous &&
      !previous.classList.contains('pz-bundle') &&
      /spend more\s*,?\s*pay less/i.test(normalize(previous.textContent)) &&
      normalize(previous.textContent).length < 120
    ) {
      previous.hidden = true;
      previous.style.setProperty('display', 'none', 'important');
    }
  };

  const markPurchaseRow = () => {
    const info = document.querySelector('.product__info-container');
    if (!info) return;
    const quantity = info.querySelector('.product-form__quantity');
    const submit = info.querySelector('.product-form__submit');
    if (quantity && submit && quantity.parentElement === submit.parentElement) {
      quantity.parentElement.classList.add('pz-competitor-purchase-row');
    }
  };

  const enhance = () => {
    if (!document.querySelector('[data-pz-product-polish]')) return;
    hideLegacyBundle();
    ensureCompetitorBundle();
    markPurchaseRow();
  };

  let raf = 0;
  const schedule = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      enhance();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  window.addEventListener('pageshow', enhance);
  document.addEventListener('product-info:loaded', enhance);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(enhance, 350);
  window.setTimeout(enhance, 1000);
  window.setTimeout(enhance, 2200);
})();

/* Draft-only Teeinblue compatibility guard.
   The product-polish section injects Shopify media controls inside #tee-gallery.
   Keep Teeinblue's preview as the sole owner of its gallery by leaving inert markers
   in place so the legacy enhancer does not re-create those controls. */
(() => {
  if (window.__pzTeeGalleryNativeMediaGuard) return;
  window.__pzTeeGalleryNativeMediaGuard = true;

  const style = document.createElement('style');
  style.id = 'pz-tee-gallery-native-media-guard';
  style.textContent = '#tee-gallery .pz-product-media-nav,#tee-gallery .pz-gallery-actions{display:none!important;}';
  (document.head || document.documentElement).appendChild(style);

  const neutralize = () => {
    const gallery = document.querySelector('#tee-gallery .tee-gallery');
    if (!gallery) return;

    const nav = gallery.querySelector('.pz-product-media-nav');
    if (nav) {
      nav.hidden = true;
      nav.setAttribute('aria-hidden', 'true');
      nav.style.setProperty('display', 'none', 'important');
      if (nav.firstChild) nav.replaceChildren();
    }

    const actions = gallery.querySelector('.pz-gallery-actions');
    if (actions) {
      actions.hidden = true;
      actions.setAttribute('aria-hidden', 'true');
      actions.style.setProperty('display', 'none', 'important');
      if (actions.firstChild) actions.replaceChildren();
    }
  };

  let raf = 0;
  const schedule = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      neutralize();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', neutralize, { once: true });
  } else {
    neutralize();
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', neutralize);
  document.addEventListener('product-info:loaded', neutralize);
  window.setTimeout(neutralize, 100);
  window.setTimeout(neutralize, 500);
  window.setTimeout(neutralize, 1500);
})();
